import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 22px;
`;

export const Error = styled.span`
  color: #cf2b23;
  font-size: 12px;
`;
